/**********************************
 * Components
 **********************************/
// Style
import "./styles/vendors/tailwind/tailwind.css";
import "./styles/styles.scss"; // reset 등 전역에서 한 번만 선언 될 scss

// Vue Setup
import App from "./App.vue";
import { createPinia } from "pinia";

// Plugins and Libraries
import router from "./router/router.js";
import _ from "lodash"; // 자바스크립트 유틸리티 라이브러리
import { fetchData } from "./utils/network/fetchData.js"; // Axios 인스턴스
import flatpickr from "flatpickr"; // datepicker 라이브러리
import { Korean } from "flatpickr/dist/l10n/ko.js"; // datepicker 라이브러리의 한국어 언어 설정
import VueClickAway from "vue3-click-away"; // 지정 영역 밖의 영역 클릭시 함수 실행 라이브러리
import "@ux-lab/web-utilities"; // UX LAB 공토 유틸리티 라이브러리

/**********************************
 * Variables
 **********************************/
// Global Settings
window.ENV ??= import.meta.env; // 환경변수 생성
window._ = _; // lodash 인스턴스 생성
window.fetchData = fetchData(); // 기존 호환성을 위한 fetchData 인스턴스

// Application Initialization
const pinia = createPinia();
const app = createApp(App);
app.use(pinia).use(router).use(VueClickAway);
app.mount("#app");

// Korean Flatpickr Settings
Korean.months.longhand = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];
flatpickr.localize(Korean);
